"use client"

import { ScrollArea } from "@/components/ui/scroll-area"
import { Comment } from "./comment"

export function CommentsPanel() {
  return (
    <ScrollArea className="flex-1">
      <div className="px-4 py-4 space-y-4">
        <Comment
          colors={['#c7c8ff', '#665cf6']}
          author="Parker Van Roy"
          timestamp="30m ago"
          content="Should we reference a separate SOW?"
        />
        <Comment
          colors={['#ec9748', '#f4633f']}
          author="Ram"
          timestamp="15m ago"
          content="Let's add a reference to Exhibit B."
        />
        <Comment
          colors={['#b5f0ff', '#06b6d4']}
          author="Gwyn Fae"
          timestamp="2h ago"
          content="We need a clause about creative control over the Masters."
        />
        <Comment
          colors={['#fff5b7', '#efdb44']}
          author="Ty Van Roy"
          timestamp="3h ago"
          content="Advance structure looks good. Let's clarify recoupment terms."
        />
      </div>
    </ScrollArea>
  )
}

